class CBProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cb-related-track');
    this.controls = this.querySelector('.cb-carousel-controls');
    this.previous = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');
    if (!this.track || !this.controls) return;
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.targetIndex = null;
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
    this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
    this.track.addEventListener('scrollend', () => { this.targetIndex = null; this.update(); }, options);
    this.track.addEventListener('pointerdown', () => { this.targetIndex = null; }, options);
    this.track.addEventListener('wheel', () => { this.targetIndex = null; }, { ...options, passive: true });
    this.track.addEventListener('keydown', event => {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move(event.key === 'ArrowLeft' ? -1 : 1);
    }, options);
    this.resize = new ResizeObserver(() => { this.targetIndex = null; this.update(); });
    this.resize.observe(this.track);
    this.update();
  }

  positions() {
    const first = this.track.firstElementChild;
    if (!first) return [];
    const origin = first.getBoundingClientRect().left + this.track.scrollLeft;
    const maximum = this.track.scrollWidth - this.track.clientWidth;
    return [...new Set([...this.track.children].map(card =>
      Math.min(maximum, Math.max(0, card.getBoundingClientRect().left + this.track.scrollLeft - origin))
    ))];
  }

  move(direction) {
    const positions = this.positions();
    if (!positions.length) return;
    const nearest = positions.reduce((best, position, index) =>
      Math.abs(position - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
    this.targetIndex = Math.max(0, Math.min(positions.length - 1, (this.targetIndex ?? nearest) + direction));
    this.track.scrollTo({ left: positions[this.targetIndex], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    this.update();
  }

  update() {
    const maximum = this.track.scrollWidth - this.track.clientWidth;
    this.controls.hidden = maximum <= 2;
    const position = this.targetIndex === null ? this.track.scrollLeft : this.positions()[this.targetIndex];
    this.previous.disabled = position <= 2;
    this.next.disabled = position >= maximum - 2;
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
  }
}
if (!customElements.get('cb-product-carousel')) customElements.define('cb-product-carousel', CBProductCarousel);
